import { globalVariables } from "helper/globalVariables";
import { Button } from "shared/Components/button";
import Dropdown from "shared/Components/dropdown";
import { dogStatus } from "helper/globalConstant";
import { DEFAULT_DATE_FORMAT } from "helper/utility";
import moment from "moment";

export const UserListCardHost = ({ userDetail, onViewMoreClick }) => {
  return (
    <div class="bg-white p-4 flex flex-col flex-1 result-card-box">
      <div className="flex flex-col">
        <div className="flex flex-row justify-between">
          <span class="text-lg font-semibold text-gray-900">
            {userDetail.location}
          </span>
          <Dropdown
            width={"w-28"}
            className="h-8 rounded-3xl"
            defaultOption={dogStatus[0]}
            dropdownOptions={dogStatus}
            isFaded={true}
          />
        </div>

        <span class="text-sm text-gray-600 font-semibold">
          {userDetail.level}
        </span>
      </div>
      <div className="pt-8 flex justify-between items-center">
        <span class="text-sm text-gray-600 font-semibold">
          {moment(userDetail.date).format(DEFAULT_DATE_FORMAT)}
        </span>
        <Button
          label={globalVariables.viewMore}
          width="w-32"
          onClick={onViewMoreClick}
        />
      </div>
    </div>
  );
};
